import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Construction, Mail, Phone } from 'lucide-react';

const UnderConstruction: React.FC = () => {
    const navigate = useNavigate();

    const handleInquiryClick = () => {
        navigate('/eligibility');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20 font-sans text-slate-800 flex flex-col items-center justify-center">
            <div className="max-w-3xl mx-auto px-6 text-center">
                <div className="mb-8 flex justify-center">
                    <div className="p-6 bg-[#009B8F]/10 rounded-full animate-pulse">
                        <Construction className="w-16 h-16 text-[#009B8F]" />
                    </div>
                </div>

                <h1 className="text-4xl md:text-5xl font-serif text-[#011E26] mb-6">Website Under Construction</h1>

                <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                    Thank you for visiting Nex Overseas. Our website is currently under construction as we update our services and resources to serve you better.
                </p>

                <div className="bg-slate-50 p-8 rounded-lg border border-slate-200 mb-10 shadow-sm">
                    <p className="text-slate-700 mb-6 font-medium">
                        In the meantime, you can still get in touch with us for any inquiries or assistance:
                    </p>

                    <div className="flex flex-col md:flex-row justify-center gap-6 mb-8">
                        <div className="flex items-center gap-3 justify-center text-slate-600">
                            <Phone className="w-5 h-5 text-[#009B8F]" />
                            <span>+44 757 743 6898</span>
                        </div>
                        <div className="flex items-center gap-3 justify-center text-slate-600">
                            <Mail className="w-5 h-5 text-[#009B8F]" />
                            <span>info@nexoverseas.co.uk</span>
                        </div>
                    </div>

                    <p className="text-slate-600 mb-6">
                        Fill out our inquiry form and our team will get back to you promptly
                    </p>

                    <button
                        onClick={handleInquiryClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Go to Inquiry Form
                    </button>
                </div>

                <p className="text-slate-500 italic">
                    We appreciate your patience and look forward to providing you with a fully updated website soon. Please check back for further updates!
                </p>
            </div>
        </div>
    );
};

export default UnderConstruction;
